export type BidResponseStageOption = {
  label: string;
  value: string;
  color?: string;
  iconColor?: string;
  iconName?: string;
};

export type GroupedBidResponseStageOptions = {
  label: string;
  options: BidResponseStageOption[];
};

type Transition = {
  id: string;
  group: string;
  order: number;
  stage: {
    id: string;
    name: string;
    color: string;
    iconColor: string;
    iconName: string;
  };
};

export function processBidResponseTransitions(
  transitions: Transition[],
): GroupedBidResponseStageOptions[] {
  return transitions
    .sort((a, b) => a.order - b.order)
    .reduce<GroupedBidResponseStageOptions[]>((acc, transition) => {
      const groupIndex = acc.findIndex((group) => group.label === transition.group);
      const option = {
        label: transition.stage.name,
        value: transition.stage.id,
        color: transition.stage.color,
        iconColor: transition.stage.iconColor,
        iconName: transition.stage.iconName,
      };
      if (groupIndex > -1) {
        acc[groupIndex].options.push(option);
      } else {
        acc.push({
          label: transition.group.replace(/_/g, " "),
          options: [option],
        });
      }
      return acc;
    }, []);
}
